/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Users_Sort_OrderInputs */

const en_tables_users_sort_order = /** @type {(inputs: Tables_Users_Sort_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

const de_tables_users_sort_order = /** @type {(inputs: Tables_Users_Sort_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order`)
};

/**
* | output |
* | --- |
* | "Order" |
*
* @param {Tables_Users_Sort_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_users_sort_order = /** @type {((inputs?: Tables_Users_Sort_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Users_Sort_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_users_sort_order(inputs)
	return de_tables_users_sort_order(inputs)
});